// RB2B visitor identification — production hosts only, and only with
// Business Visitor Identification consent (see consentRuntime.ts).
import { isProductionHost } from './env';

const RB2B_KEY = '4N210HX3E26Z';

export function isRB2BLoaded() {
  return !!(window as unknown as { reb2b?: unknown }).reb2b;
}

export function initRB2B() {
  if (typeof window === 'undefined' || !isProductionHost()) return;
  const w = window as unknown as { reb2b?: { loaded?: boolean } };
  if (w.reb2b) return;
  w.reb2b = { loaded: true };
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://ddwl4m2hdecbv.cloudfront.net/b/${RB2B_KEY}/${RB2B_KEY}.js.gz`;
  const first = document.getElementsByTagName('script')[0];
  first?.parentNode?.insertBefore(s, first);
}
